export default {
  title: 'Pontos e Descontos',
  store_credit: 'Crédito em loja',
  points_balance: 'Saldo de pontos',
};
